import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// モジュールのインポート
import { initDataCountUpAnimation } from "./recruit-data-counter.js";
import { initHeaderStyleControl } from "./recruit-header-control.js";
import { initSideNavigation } from "./recruit-side-nav.js";
import { initStaffVoiceAnimation } from "./recruit-staff-voices.js";
import { initHeroAnimation, initHeroScrollAnimation, initHeroPinAnimation } from "./recruit-hero.js";

/**
 * Recruit Animation - Main Coordinator
 * リクルートページアニメーションの統合管理
 */

export function animationRecruit() {
  // GSAPプラグイン登録
  gsap.registerPlugin(ScrollTrigger);
  
  try {
    // 1. ヒーローアニメーション（最初に実行）
    initHeroAnimation();
    
    // 2. ヒーロースクロールアニメーション
    initHeroScrollAnimation();

    // 3. ヒーローPINアニメーション
    initHeroPinAnimation();

    // 4. データカウンターアニメーション
    initDataCountUpAnimation();

    // 5. サイドナビゲーション制御
    initSideNavigation();

    // 6. ヘッダースタイル制御
    initHeaderStyleControl();

    // 7. スタッフボイスアニメーション
    initStaffVoiceAnimation();
    
  } catch (error) {
    console.error('❌ Error initializing recruit animations:', error);
  }
  
}